export default {
  state: {
    locationSelected: "",
    resourceSelected: "",
    resourceTypesSelected: [],
    ownerGroupsSelected: [],
    statusesSelected: [],
    subjectsSelected: [],
    levelsSelected: [],
    syllabusSelected: null,
    parentTopicsSelected: [],
    topicsSelected: [],
    learningOutcomesSelected: [],
    keyword: "",

    contentMapData: [],
    filterChanged: false,
  },
  resetSubjectAndLevel() {
    this.state.subjectsSelected = [];
    this.state.levelsSelected = [];
  },
  getLocationSelected() {
    return this.state.locationSelected;
  },
  setLocationSelected(locationSelected) {
    this.state.locationSelected = locationSelected;
    this.state.filterChanged = true;
  },
  getResourceSelected() {
    return this.state.resourceSelected;
  },
  setResourceSelected(resourceSelected) {
    this.state.resourceSelected = resourceSelected;
    this.state.filterChanged = true;
  },
  getResourceTypesSelected() {
    return this.state.resourceTypesSelected;
  },
  setResourceTypesSelected(resourceTypesSelected) {
    this.state.resourceTypesSelected = resourceTypesSelected;
    this.state.filterChanged = true;
  },
  getOwnerGroupsSelected() {
    return this.state.ownerGroupsSelected;
  },
  setOwnerGroupsSelected(ownerGroupsSelected) {
    this.state.ownerGroupsSelected = ownerGroupsSelected;
    this.state.filterChanged = true;
  },
  getStatusesSelected() {
    return this.state.statusesSelected;
  },
  setStatusesSelected(statusesSelected) {
    this.state.statusesSelected = statusesSelected;
    this.state.filterChanged = true;
  },
  getSubjectsSelected() {
    return this.state.subjectsSelected;
  },
  setSubjectsSelected(subjectsSelected) {
    this.state.subjectsSelected = subjectsSelected;
    this.state.filterChanged = true;
  },
  getLevelsSelected() {
    return this.state.levelsSelected;
  },
  setLevelsSelected(levelsSelected) {
    this.state.levelsSelected = levelsSelected;
    this.state.filterChanged = true;
  },
  getSyllabusSelected() {
    return this.state.syllabusSelected;
  },
  setSyllabusSelected(syllabusSelected) {
    this.state.syllabusSelected = syllabusSelected;
    this.state.filterChanged = true;
  },
  getParentTopicsSelected() {
    return this.state.parentTopicsSelected;
  },
  setParentTopicsSelected(parentTopicsSelected) {
    this.state.parentTopicsSelected = parentTopicsSelected;
    this.state.filterChanged = true;
  },
  getTopicsSelected() {
    return this.state.topicsSelected;
  },
  setTopicsSelected(topicsSelected) {
    this.state.topicsSelected = topicsSelected;
    this.state.filterChanged = true;
  },
  getLearningOutcomesSelected() {
    return this.state.learningOutcomesSelected;
  },
  setLearningOutcomesSelected(learningOutcomesSelected) {
    this.state.learningOutcomesSelected = learningOutcomesSelected;
    this.state.filterChanged = true;
  },
  getKeyword() {
    return this.state.keyword;
  },
  setKeyword(keywords) {
    this.state.keyword = keywords;
  },
  getContentMapData() {
    return this.state.contentMapData;
  },
  setContentMapData(data) {
    this.state.contentMapData = data;
  },
  getHasFilterChanged() {
    return this.state.filterChanged;
  },
  setHasFilterChanged(value) {
    this.state.filterChanged = value;
  },

  resetFiltersSelected() {
    this.state.locationSelected = "";
    this.state.resourceSelected = "";
    this.state.resourceTypesSelected = [];
    this.state.ownerGroupsSelected = [];
    this.state.statusesSelected = [];
    this.state.subjectsSelected = [];
    this.state.levelsSelected = [];
    this.state.syllabusSelected = null;
    this.state.parentTopicsSelected = [];
    this.state.topicsSelected = [];
    this.state.learningOutcomesSelected = [];
  },

  destroy() {
    this.state = {
      locationSelected: "",
      ownerGroupsSelected: [],
      statusesSelected: [],
      subjectsSelected: [],
      levelsSelected: [],
      syllabusSelected: null,
      parentTopicsSelected: [],
      topicsSelected: [],
      learningOutcomesSelected: [],
      keyword: "",
      contentMapData: [],
      resourceSelected: "",
      resourceTypesSelected: [],
    };
  },
};
